import React from "react";
import ModalProps from "@ltypes/modalProps";
import './Modal.scss';

function Modal(props: { children: React.ReactNode } & ModalProps) {

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            props.onHide();
        }
    };

    return (
        <div className={`modal-overlay ${props.visible ? 'visible' : ''}`} onClick={handleOverlayClick}>
            <div className={`modal-content ${props.visible ? 'visible' : ''} ${props.className ?? ''}`}>
                {props.children}
            </div>
        </div>
    );
}

export default Modal;
